import React from 'react';
import { useHistory } from 'react-router-dom';

export const NotFound = () => {
  const history = useHistory();
  return (
    <main className="login white flex-column aic jcc">
      <h1 style={{ fontSize: '2rem', marginBottom: '2rem' }}>Oops! Sorry, This page isn&apos;t available...</h1>
      <button onClick={() => history.push('/home')} className="btn white-bg">
        Go to Homepage
      </button>
    </main>
  );
};
